'use strict';

var loadMessagesAsync = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(options) {
        var endDate, count, invocationData, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        endDate = new Date().toISOString();

                        console.log(endDate);
                        if (options.endDate) {
                            endDate = options.endDate;
                        }

                        console.log(endDate);

                        count = mymobileConfig.secure_messaging.per_page;

                        if (options.count) {
                            count = options.count;
                        }

                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getMessages',
                            parameters: [Auth.token(), Auth.patientId(), { end_date: endDate, limit: count }]
                        };
                        _context.next = 9;
                        return WL.Client.post(invocationData);

                    case 9:
                        result = _context.sent;
                        return _context.abrupt('return', result.invocationResult);

                    case 11:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function loadMessagesAsync(_x) {
        return _ref.apply(this, arguments);
    };
}();

var modifyMessageAsync = function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(messageJSON) {
        var invocationData, result;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: "modifyMessage",
                            parameters: [Auth.token(), Auth.patientId(), messageJSON]
                        };
                        _context2.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context2.sent;
                        return _context2.abrupt('return', result);

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function modifyMessageAsync(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var loadInterviewsAsync = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var invocationData, result;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getInterviews',
                            parameters: [Auth.token(), Auth.patientId()]
                        };
                        _context3.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context3.sent;

                        result.invocationResult.patientId = Auth.patientId();
                        Store.saveInterviews(result.invocationResult);
                        Interviews.init(result.invocationResult);

                    case 7:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function loadInterviewsAsync() {
        return _ref3.apply(this, arguments);
    };
}();

var loadPrivacyPolicyAsync = function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(callback) {
        var invocationData, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getPrivacyPolicy',
                            parameters: [Auth.token(), Auth.patientId()]
                        };
                        _context4.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context4.sent;

                        Store.savePrivacyPolicy(result.invocationResult);

                    case 5:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function loadPrivacyPolicyAsync(_x3) {
        return _ref4.apply(this, arguments);
    };
}();

var loadProfileAsync = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(callback) {
        var invocationData, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getProfile',
                            parameters: [Auth.token(), Auth.patientId()]
                        };
                        _context5.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context5.sent;

                        result.invocationResult.patientId = Auth.patientId();
                        Store.saveProfiles(result.invocationResult);
                        Profile.init(result.invocationResult);

                    case 7:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function loadProfileAsync(_x4) {
        return _ref5.apply(this, arguments);
    };
}();

var getAppointments = function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var invocationData, result, rawData, apptArray, key;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getAppointments',
                            parameters: [Auth.token(), Auth.patientId()]
                        };
                        _context6.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context6.sent;
                        rawData = result.invocationResult;
                        apptArray = [];

                        for (key in rawData) {
                            apptArray.push(rawData[key]);
                        }
                        return _context6.abrupt('return', Appointment.loadFromJson(apptArray));

                    case 8:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function getAppointments() {
        return _ref6.apply(this, arguments);
    };
}();

var getPatient = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        var invocationData, result;
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getPatient',
                            parameters: [Auth.token(), Auth.patientId()]
                        };
                        _context7.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context7.sent;
                        return _context7.abrupt('return', result.invocationResult);

                    case 5:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function getPatient() {
        return _ref7.apply(this, arguments);
    };
}();

var updatePatient = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(patientJson) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'updatePatient',
                            parameters: [Auth.token(), Auth.patientId(), patientJson]
                        };
                        return _context8.abrupt('return', WL.Client.post(invocationData));

                    case 2:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function updatePatient(_x5) {
        return _ref8.apply(this, arguments);
    };
}();

var getSettings = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var invocationData, result;
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getSettings',
                            parameters: ["es"]
                        };
                        _context9.next = 3;
                        return WL.Client.post(invocationData);

                    case 3:
                        result = _context9.sent;
                        return _context9.abrupt('return', result.invocationResult);

                    case 5:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function getSettings() {
        return _ref9.apply(this, arguments);
    };
}();

var getConsent = function () {
    var _ref10 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(params) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'getConsent',
                            parameters: [Auth.token(), Auth.patientId(), params]
                        };
                        return _context10.abrupt('return', WL.Client.invokeProcedureDeferred(invocationData));

                    case 2:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function getConsent(_x6) {
        return _ref10.apply(this, arguments);
    };
}();

var postLoginAsync = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11(params) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'login',
                            parameters: [params]
                        };
                        return _context11.abrupt('return', WL.Client.post(invocationData));

                    case 2:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function postLoginAsync(_x7) {
        return _ref11.apply(this, arguments);
    };
}();

var postSubmit2fa = function () {
    var _ref12 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12(params) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'submit2fa',
                            parameters: [params]
                        };
                        return _context12.abrupt('return', WL.Client.post(invocationData));

                    case 2:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function postSubmit2fa(_x8) {
        return _ref12.apply(this, arguments);
    };
}();

var postRequest2fa = function () {
    var _ref13 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(params) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'request2fa',
                            parameters: [params]
                        };
                        return _context13.abrupt('return', WL.Client.post(invocationData));

                    case 2:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function postRequest2fa(_x9) {
        return _ref13.apply(this, arguments);
    };
}();

var postSessionUpdateAsync = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(params) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'login',
                            parameters: [params]
                        };
                        return _context14.abrupt('return', WL.Client.post(invocationData));

                    case 2:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function postSessionUpdateAsync(_x10) {
        return _ref14.apply(this, arguments);
    };
}();

var syncAllASync = function () {
    var _ref15 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        checkNetworkConnection();
                        submitPendingInterviews();
                        submitPendingMessages();
                        submitHealthkitData();
                        _context15.next = 6;
                        return loadInterviewsAsync();

                    case 6:
                        _context15.next = 8;
                        return Promise.all([loadProfileAsync(), loadPrivacyPolicyAsync(), getAppointments()]);

                    case 8:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function syncAllASync() {
        return _ref15.apply(this, arguments);
    };
}();

var finishLogin = function () {
    var _ref16 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(rememberMe) {
        return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:

                        clearSyncingInterviews();
                        _context16.next = 3;
                        return syncAllASync();

                    case 3:
                        Auth.initLogin(rememberMe);

                    case 4:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function finishLogin(_x11) {
        return _ref16.apply(this, arguments);
    };
}();

var postRegisterAsync = function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(params) {
        var invocationData;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        invocationData = {
                            adapter: 'tmapi',
                            procedure: 'register',
                            parameters: [params]
                        };
                        return _context17.abrupt('return', WL.Client.post(invocationData));

                    case 2:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function postRegisterAsync(_x12) {
        return _ref17.apply(this, arguments);
    };
}();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/* exported getResponseApiVersions loadInterviews loadPrivacyPolicy getVitals
            postInterviews postGetGraphData postLogin postRegister postReadings
            postOAuth2Token getApplicationVersion getConfigFromServer  */

function getResponseApiVersions(xhr) {
    return WL.Client.makeUrl.getApiVersions(xhr);
}

function getVitals(params, response) {
    var invocationData = {
        adapter: 'tmapi',
        procedure: 'getVitals',
        parameters: [Auth.token(), Auth.patientId(), params]
    };
    WL.Client.invokeProcedure(invocationData, response);
}

function postConsent(val) {
    var invocationData = {
        adapter: "tmapi",
        procedure: 'postConsent',
        parameters: [Auth.token(), Auth.patientId(), val]
    };

    return WL.Client.invokeProcedureDeferred(invocationData);
}

function postMessages(messagesJSON, response) {
    var invocationData = {
        adapter: "tmapi",
        procedure: 'postMessages',
        parameters: [Auth.token(), Auth.patientId(), messagesJSON]
    };
    WL.Client.invokeProcedure(invocationData, response);
}

function postInterviews(interviewXML, response) {
    var invocationData = {
        adapter: 'tmapi',
        procedure: 'postInterviews',
        parameters: [Auth.token(), interviewXML]
    };
    WL.Client.invokeProcedure(invocationData, response);
}

function postGetGraphData(params, response) {
    var invocationData = {
        adapter: 'tmapi',
        procedure: 'postGetGraphData',
        parameters: [Auth.token(), params]
    };
    WL.Client.invokeProcedure(invocationData, response);
}

function postReadings(params, response) {
    var invocationData = {
        adapter: 'tmapi',
        procedure: 'postReadings',
        parameters: [Auth.token(), Auth.patientId(), params]
    };
    return WL.Client.invokeProcedureDeferred(invocationData);
}

function postOAuth2Token(params, response) {
    var invocationData = {
        adapter: 'tmapi',
        procedure: 'postOAuth2Token',
        parameters: [params]
    };
    WL.Client.invokeProcedure(invocationData, response);
}

function getApplicationVersion() {
    var invocationData = {
        adapter: 'mymobileapi',
        procedure: 'getApplicationVersion',
        parameters: []
    };
    return WL.Client.invokeProcedureDeferred(invocationData);
}

function getConfigFromServer() {
    var req2 = $.ajax({
        url: WL.Client.makeUrl("config/local-config.js"),
        dataType: "text",
        timeout: 6000 // limit wait time at startup
    });

    req2.done(function (data) {
        var ok = false;
        try {
            // could happen that server local config from a newer server overrides a value
            // that doesn't exist yet in our app-config, just fail in that case, they
            // should be updating their app soon.
            eval(data);
            ok = true;
        } catch (e) {
            console.log(data);
            console.error("Failed getConfigFromServer:");
            console.error(e);
        }

        if (ok) {
            console.log("Got local config");
            localStorage.setItem("localConfig", JSON.stringify(mymobileConfig));
        }
    }).fail(function (jqXHR, textStatus, errorThrown) {
        console.log('Failed getConfigFromServer:' + textStatus);
        console.log(errorThrown);
    });

    var req3 = $.ajax({
        url: WL.Client.makeUrl("locales/translations.js"),
        dataType: "text",
        timeout: 6000 // limit wait time at startup
    });

    req3.done(function (data) {
        var ok = false;
        var savedTranslations = I18N_TRANSLATIONS;
        try {
            eval(data);
            ok = true;
        } catch (e) {
            console.log(data);
            console.error("Failed getConfigFromServer: (translations)");
            console.error(e);
        }

        if (ok) {
            $.extend(true, savedTranslations, I18N_TRANSLATIONS);
            I18N_TRANSLATIONS = savedTranslations;
            console.log("Got translations");
            localStorage.setItem("translations", JSON.stringify(I18N_TRANSLATIONS));
        }
    }).fail(function (jqXHR, textStatus, errorThrown) {
        console.error('Failed getConfigFromServer (translations):' + textStatus);
        console.error(errorThrown);
    });

    var deferred = $.Deferred();

    $.when(req3, req2).always(function (v1, v2) {
        deferred.resolve();
    });

    return deferred.promise();
}